import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { PhasrMonitoredRulesGridBaseDataProvider } from '../dataProvider/PhasrMonitoredRulesGridBaseDataProvider';

export class PhasrMonitoredRulesGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, PhasrMonitoredRulesGridBaseDataProvider);
  }
}
